import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { customerApi } from "@/lib/api";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useCustomerAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const session_id = decodeURIComponent(m[1]);
    customerApi.post("/customer/google/session", { session_id, base_url: window.location.origin })
      .then(({ data }) => {
        setSession(data.token, data.customer);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account");
      })
      .catch(() => navigate("/login"));
  }, [navigate, setSession]);

  return <div className="min-h-screen grid place-items-center text-muted-foreground">Signing you in…</div>;
}
